import styles from "./ProfilePublic.module.css";
import { Link } from "react-router-dom";
import ProfileButtons from "./ProfileButtons";
import translations from './translation.js';
import Level from "./Level.jsx";

const ProfileInfo = ({ isOwn, picture, discord, username, exp, followers, following }) => {
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

  return (
    <>
      <div className={`${styles.profileInfoContainer} ${styles.desktop}`}>
        <div className={styles.infoRow1}>
          <div>
            <img src={picture} alt="user avatar" className={styles.profilePic}></img>
            <Level experience={exp} language={currentLanguage} />
          </div>
          <div>
            <h2 className={styles.nameStyle}>{username}</h2>
            <p className={styles.discordLabel}>Discord:</p>
            <p className={styles.discord}>{discord}</p>
          </div>
          <div className={styles.connectionsContainer}>
            <div className={styles.count}>
              <Link to="followers" style={{ textDecoration: 'none', color: 'white' }}>
                <p className={styles.connectionCount}>{followers}<br/><span className={styles.connectionsText}>{translations[currentLanguage].followers}</span></p>
              </Link>
            </div>
            <div className={styles.count}>
              <Link to="following" style={{ textDecoration: 'none', color: 'white' }}>
                <p className={styles.connectionCount}>{following}<br/><span className={styles.connectionsText}>{translations[currentLanguage].following}</span></p>
              </Link>
            </div>
          </div>
        </div>
        <div className={styles.infoRow2}>
          <ProfileButtons isOwn={isOwn} />
        </div>
      </div>
      <div className={`${styles.profileInfoContainerMobile} ${styles.mobile}`}>
        <div className={styles.infoRow1}>
          <img src={picture} alt="user avatar" className={styles.profilePic}></img>
          <div>
            <h2 className={styles.nameStyle}>{username}</h2>
            <p className={styles.discordLabel}>Discord:</p>
            <p className={styles.discord}>{discord}</p>
          </div>
          <div className={styles.connectionsContainer}>
            <div className={styles.count}>
              <Link to="followers" style={{ textDecoration: 'none', color: 'white' }}>
                <p className={styles.connectionCount}>{followers} <span className={styles.connectionsText}>{translations[currentLanguage].followers}</span></p>
              </Link>
            </div>
            <div className={styles.count}>
              <Link to="following" style={{ textDecoration: 'none', color: 'white' }}>
                <p className={styles.connectionCount}>{following} <span className={styles.connectionsText}>{translations[currentLanguage].following}</span></p>
              </Link>
            </div>
          </div>
        </div>
        <div className={styles.infoRow2}>
          <ProfileButtons isOwn={isOwn} />
        </div>
      </div>
    </>
  );
}

export default ProfileInfo;
